export default __webpack_public_path__ + "static/media/search-tc-icon.f86ea494.svg";